export default {
    title: 'Propose innovation project',
    subHeadline: 'Are you working on an exciting innovation project that you would like to make visible in your company? You can use the form below to propose an innovation project for the presentation in the Trendmanager. The Trendmanager administrators of your company will contact you with the following steps.',

    form: {
        title: 'Title',
        description: 'Description'
    },

    validation: {
        title: 'Please enter a title',
        description: 'Please enter a description'
    },

    buttons: {
        abort: 'Cancel',
        submit: 'Submit'
    }
}
